export default "__VITE_ASSET__BeC_$Ega__"